export default __webpack_public_path__ + "static/vegas-930d973c33b0445f543d9afaa84bcd25.jpg";